import type { Episode } from '@/payload-types'

import { Section, Heading, Stack } from '@systhemaui/react'
import { Lexical } from '@systhemaui/payload/lexical'
import { EpisodeItem } from './EpisodeItem'

type EpisodesListProps = {
  episodes: Episode[]
  showHeader?: boolean
  headerTitle?: string
  isSignedIn?: boolean
  slug?: string
}

function Separator() {
  return (
    <div className="w-full py-7">
      <div className="h-px w-full bg-(--color-separator-line)" />
    </div>
  )
}

const EpisodesList: React.FC<EpisodesListProps> = ({
  episodes: originalEpisodes,
  showHeader = true,
  headerTitle = 'Epizódok',
  isSignedIn = false,
  slug,
}) => {
  if (!originalEpisodes || originalEpisodes.length === 0) {
    return null
  }

  // When showHeader is false, render without Section wrapper
  if (!showHeader) {
    return (
      <Stack direction="col" gap="none" className="w-full">
        {originalEpisodes.map((episode, index) => (
          <div key={episode.id}>
            {index > 0 && <Separator />}
            <EpisodeItem
              episode={episode}
              isFirst={index === 0}
              isSignedIn={isSignedIn}
              slug={slug}
              descriptionJSX={episode.description ? <Lexical data={episode.description} /> : null}
            />
          </div>
        ))}
      </Stack>
    )
  }

  return (
    <Section theme="default" className="episodes-list pt-0">
      <Stack direction="col" gap="none" className="w-full">
        {/* Header */}
        <div className="flex w-full flex-wrap items-center gap-(--gap-sm) pt-6">
          <Heading.h4 className="min-w-0 flex-1">{headerTitle}</Heading.h4>
        </div>

        {/* Episodes list */}
        {originalEpisodes.map((episode, index) => (
          <div key={episode.id}>
            {index > 0 && <Separator />}
            <EpisodeItem
              episode={episode}
              isFirst={index === 0}
              isSignedIn={isSignedIn}
              slug={slug}
              descriptionJSX={episode.description ? <Lexical data={episode.description} /> : null}
            />
          </div>
        ))}
      </Stack>
    </Section>
  )
}

export default EpisodesList
